import { CustomSlateNodeType } from 'components/TemplateEditor/types';
import { Descendant, Text } from 'slate';

export const defaultDescendants: Descendant[] = [
  {
    type: CustomSlateNodeType.PARAGRAPH,
    children: [
      {
        text: '',
      },
    ],
  },
];

export function segments2descendants(segments: Knowledge.SPU.Segment[] = []) {
  const descendants = segments.reduce<Descendant[]>((res, { type, content }) => {
    if (type === 'TEXT') {
      const pre = res[res.length - 1];

      if (pre && pre.type === CustomSlateNodeType.PARAGRAPH) {
        const last = pre.children[pre.children.length - 1];

        if (Text.isText(last)) {
          last.text += content;

          return res;
        }
      }

      res.push({
        type: CustomSlateNodeType.PARAGRAPH,
        children: [
          {
            text: content,
          },
        ],
      });

      return res;
    }

    res.push({
      type: CustomSlateNodeType.UPLOAD,
      uploadType: type,
      id: content,
      children: [{ text: '' }],
    });

    return res;
  }, []);

  return descendants.length > 0 ? descendants : defaultDescendants;
}

export function descendants2segments(descendants: Descendant[] = []) {
  return descendants
    .reduce<Knowledge.SPU.Segment[]>((res, cur) => {
      if (cur.type === CustomSlateNodeType.UPLOAD) {
        res.push({
          type: cur.uploadType,
          content: cur.id,
        });

        return res;
      }

      if (cur.type === CustomSlateNodeType.PARAGRAPH) {
        return cur.children.reduce((res, cur) => {
          if (!Text.isText(cur)) {
            return res;
          }

          const pre = res[res.length - 1];

          if (pre?.type === 'TEXT') {
            pre.content += cur.text;
          } else {
            res.push({
              type: 'TEXT',
              content: cur.text,
            });
          }

          return res;
        }, res);
      }

      return res;
    }, [])
    .filter(({ type, content }) => type !== 'TEXT' || content);
}

export function getTextLength(descendants: Descendant[] = []) {
  return descendants.reduce((res, cur) => {
    if (cur.type === CustomSlateNodeType.PARAGRAPH) {
      return cur.children.reduce((res, cur) => {
        if (Text.isText(cur)) {
          return res + cur.text.length;
        }

        return res;
      }, res);
    }

    return res;
  }, 0);
}

export function isEmptyDescendants(descendants: Descendant[] = []) {
  return descendants.every((descendant) => {
    return (
      descendant.type === CustomSlateNodeType.PARAGRAPH &&
      descendant.children.every((child) => {
        return Text.isText(child) && (!child.text || !child.text.trim());
      })
    );
  });
}
